<ion-header>
    <ion-toolbar #toolbar>
        <ion-buttons slot="start">
            <ion-button appClick (clicked)="onClose()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title><span id="page-title-span">{{ 'Aufträge sortieren' | translate }}</span></ion-title>
    </ion-toolbar>
</ion-header>
<ion-content>
    <ion-list>
        <ion-reorder-group [disabled]="false" (ionItemReorder)="handleReorder($any($event))">
            <app-auftragitem
                             *ngFor="let item of auftraege"
                             [auftrag]="item"
                             [style.height]="item.itemHeight"
                             [style.minHeight]="minItemHeight"
                             [reorder]="true">
            </app-auftragitem>
        </ion-reorder-group>
    </ion-list>
</ion-content>